//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button'
import SUPERVISORS from '@/constants/supervisor'
import Multiselect from 'vue-multiselect'
import AddSupervisorModalProjectDetail from '@/components/Projects/Detail/Tabs/Supervisors/AddSupervisorModalProjectDetail.vue'
import MassiveImportSupervisorProjectDetailModal from '@/components/Projects/Detail/Tabs/Supervisors/MassiveImportSupervisorProjectDetailModal.vue'
import MassiveImportInfoSupervisorProjectDetailModal from '@/components/Projects/Detail/Tabs/Supervisors/MassiveImportInfoSupervisorProjectDetailModal'
import ModalResendMassiveInvitation from '@/components/Projects/Detail/Tabs/Supervisors/ModalResendMassiveInvitation'
import ModalErrorUsers from '@/components/Projects/users/ModalErrorUsers.vue'
import SupervisorsList from './Supervisors/SupervisorsList.vue'

export default {
  name: 'SupervisorsTab',
  components: {
    Multiselect,
    Button,
    SupervisorsList,
    AddSupervisorModalProjectDetail,
    MassiveImportSupervisorProjectDetailModal,
    MassiveImportInfoSupervisorProjectDetailModal,
    ModalResendMassiveInvitation,
    ModalErrorUsers,
  },
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  async fetch() {
    await this.refreshSupervisors()
  },
  data() {
    return {
      invitationStatus: [],
      term: '',
      checkedRows: [],
      supervisors: [],
      mainCheck: false,
      allRowsChecked: false,
      isShowModalSupervisors: false,
      availableSupervisors: [],
      isShowModalMassiveImportSupervisor: false,
      isShowModalInfoMassiveImportSupervisor: false,
      supervisorsImported: [],
      invitationsModalVisible: false,
      disabledMainCheck: false,
      textModalErrorUsers: '',
      isShowModalErrorUsers: false,
    }
  },
  computed: {
    optionStatus() {
      return Object.values(SUPERVISORS.INVITATION_STATUS)
    },
    invitationStatusFilter() {
      if (!this.invitationStatus) {
        return null
      }
      return this.invitationStatus.value
    },
  },
  methods: {
    getCheckedRows(rows) {
      this.checkedRows = rows
    },
    toggleCheckAllRows() {
      this.allRowsChecked = !this.allRowsChecked
    },
    async getSupervisors() {
      this.supervisors = await this.$repository.user.findSupervisorsWithCollaboratorsByProject(
        {
          project: this.project.id,
        }
      )
      this.supervisors.forEach((supervisor) => {
        const collabs = supervisor.collaborators
        if (collabs.length > 0) {
          const progress = parseInt(
            (collabs.filter((collab) => collab.validation_status === 'FINISHED')
              .length /
              collabs.length) *
              100
          )
          supervisor.progress = progress
        } else {
          supervisor.progress = 0
        }
      })
    },
    getIsAllChecked(checked) {
      this.mainCheck = checked
    },
    toggleModalSupervisors() {
      this.isShowModalSupervisors = !this.isShowModalSupervisors
    },
    async finishSaveSupervisor() {
      this.isShowModalSupervisors = false
      await this.refreshSupervisors()
    },
    handleMassiveSupervisorModal() {
      this.toggleModalSupervisors()
      this.toggleMassiveImportSupervisorModal()
    },
    toggleMassiveImportSupervisorModal() {
      this.isShowModalMassiveImportSupervisor = !this
        .isShowModalMassiveImportSupervisor
    },
    getSupervisorsImported(supervisorsImported) {
      this.$store.commit('loading', true)
      this.supervisorsImported = supervisorsImported

      this.toggleMassiveImportSupervisorModal()
      this.toggleModalConfirmRegisterMassiveSupervisors()
      this.$store.commit('loading', false)
    },
    toggleModalConfirmRegisterMassiveSupervisors() {
      this.isShowModalInfoMassiveImportSupervisor = !this
        .isShowModalInfoMassiveImportSupervisor
    },
    async finishMassiveSupervisor() {
      this.toggleModalConfirmRegisterMassiveSupervisors()
      await this.refreshSupervisors()
    },
    async getCompanyUsers(companyId) {
      const companyUsers = await this.$repository.user.findWithProjectRolesByCompany(
        {
          company: companyId,
        }
      )

      return companyUsers.map((user) => {
        const projectRole = user.project_roles?.find(
          (projectRole) => projectRole.project === this.project.id
        )
        return {
          ...user,
          projectRole: projectRole || null,
        }
      })
    },
    async refreshSupervisors() {
      await this.getSupervisors()
      await this.getAvailableSupervisors()
    },
    async getAvailableSupervisors() {
      const companyUsers = await this.$repository.user.findWithProjectRolesByCompany(
        {
          company: this.$strapi.user.company.id,
        }
      )
      const projectUsers = await this.$repository.user.findWithProjectRolesByProject(
        {
          project: this.project.id,
        }
      )

      const projectUsersIds = projectUsers.map((user) => user.id)

      this.availableSupervisors = companyUsers.filter(
        (companyUser) => !projectUsersIds.includes(companyUser.id)
      )
    },
    goToCollaborators() {
      this.$emit('go-to-collaborators')
    },
    async sendSupervisorInvitations() {
      const supervisorsIds = this.checkedRows.map((sv) => sv.user)
      this.$store.commit('loading', true)
      try {
        await this.$repository.invitation.supervisorReminderInvitation({
          usersIds: supervisorsIds,
          projectId: this.project.id,
        })
        this.$store.commit('loading', false)
        this.invitationsModalVisible = true
      } catch (e) {
        this.$store.commit('loading', false)
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          duration: 5000,
        })
      }
    },
    onInvitationsModalClose() {
      this.invitationsModalVisible = false
    },
    onAssignCollaboratorsLater(collaborators) {
      this.$emit('assign-collaborators-later', collaborators)
    },
    clearSelecetedRows() {
      this.$refs.supervisorsListRef.clearSelecetedRows()
    },
    toogleModalErrorUsers() {
      this.isShowModalErrorUsers = !this.isShowModalErrorUsers
    },
    handleUserWithError(message) {
      this.textModalErrorUsers = message
      this.isShowModalErrorUsers = true
    },
  },
}
